import Cookies from 'js-cookie'
import store from '@/store'
// Constants
import CONSTANTS from '@/utils/const'

const TokenKey = 'Tracker-Token'
const oneMinuteInDays = CONSTANTS.time.ONE_MINUTE_IN_DAYS
const hoursToDays = CONSTANTS.time.HOURS_TO_DAYS

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  const expDate = store.getters.expDate ? ((store.getters.expDate / hoursToDays) - oneMinuteInDays) : ''
  return Cookies.set(TokenKey, token, {
    expires: expDate })
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function removeAll() {
  Object.keys(Cookies.get()).forEach(cookieName => {
    Cookies.remove(cookieName)
  })
}
